import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Box, Button, Stack } from '@mui/material';
import { styled } from '@mui/material/styles';
import VisibilityIcon from '@mui/icons-material/Visibility';
import MoneyIcon from '@mui/icons-material/Money';

const NavButton = styled(Button)(({ theme, activeitem }) => ({
    textTransform: 'none',
    fontSize: theme.typography.fontSize,
    padding: theme.spacing(1, 1.8),
    borderRadius: theme.spacing(1.5),
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.8),
    color: activeitem === 'true' ? theme.palette.primary.main : theme.palette.text.primary,
    backgroundColor: activeitem === 'true' ? 'rgba(37, 99, 235, 0.08)' : theme.palette.background.paper,
    border: `1px solid ${activeitem === 'true' ? 'rgba(37, 99, 235, 0.20)' : theme.palette.divider}`,
    fontWeight: activeitem === 'true' ? 700 : 600,
    '&:hover': {
        backgroundColor: activeitem === 'true' ? 'rgba(37, 99, 235, 0.12)' : theme.palette.action.hover,
    },
}));

const NavLinks = () => {
    const location = useLocation();
    const basePath = location.pathname
        .replace(/\/(view-student|statistics|assign-fee)(\/.*)?$/, '')
        .replace(/\/+$/, '');

    const tabs = [
        { label: 'Overview', path: 'view-student', icon: <VisibilityIcon /> },
        { label: 'Student Fee', path: 'assign-fee', icon: <MoneyIcon /> },
    ];

    return (
        <Box sx={{ mb: 2 }}>
            <Stack direction="row" spacing={1.2} useFlexGap flexWrap="wrap">
                {tabs.map((tab) => {
                    const active = location.pathname.endsWith(tab.path);
                    return (
                        <NavButton
                            key={tab.path}
                            component={Link}
                            to={`${basePath}/${tab.path}`}
                            startIcon={tab.icon}
                            activeitem={active ? 'true' : 'false'}
                        >
                            {tab.label}
                        </NavButton>
                    );
                })}
            </Stack>
        </Box>
    );
};

export default NavLinks;
